import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Documents: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_28364)'>
        <path
          d='M15.6125 18.3716V2.07535C15.6125 1.78179 15.3735 1.54297 15.0798 1.54297H4.07372C3.77999 1.54297 3.54102 1.78179 3.54102 2.07535V18.3716C3.54102 18.6652 3.77998 18.904 4.07372 18.904H15.0798C15.3735 18.904 15.6125 18.6652 15.6125 18.3716ZM13.9873 16.8647H5.16621C5.01661 16.8647 4.89535 16.7435 4.89535 16.594C4.89535 16.4445 5.01663 16.3233 5.16621 16.3233H13.9873C14.1369 16.3233 14.2582 16.4445 14.2582 16.594C14.2582 16.7435 14.1369 16.8647 13.9873 16.8647ZM13.9873 14.3093H5.16621C5.01661 14.3093 4.89535 14.1881 4.89535 14.0386C4.89535 13.8891 5.01663 13.7679 5.16621 13.7679H13.9873C14.1369 13.7679 14.2582 13.8891 14.2582 14.0386C14.2582 14.1881 14.1369 14.3093 13.9873 14.3093ZM13.9873 11.7539H5.16621C5.01661 11.7539 4.89535 11.6327 4.89535 11.4832C4.89535 11.3336 5.01663 11.2125 5.16621 11.2125H13.9873C14.1369 11.2125 14.2582 11.3336 14.2582 11.4832C14.2582 11.6327 14.1369 11.7539 13.9873 11.7539ZM13.9873 9.19843H5.16621C5.01661 9.19843 4.89535 9.07722 4.89535 8.92773C4.89535 8.77823 5.01663 8.65703 5.16621 8.65703H13.9873C14.1369 8.65703 14.2582 8.77823 14.2582 8.92773C14.2582 9.07724 14.1369 9.19843 13.9873 9.19843ZM13.9873 6.64301H5.16621C5.01661 6.64301 4.89535 6.52182 4.89535 6.37231C4.89535 6.2228 5.01663 6.10161 5.16621 6.10161H13.9873C14.1369 6.10161 14.2582 6.2228 14.2582 6.37231C14.2582 6.52182 14.1369 6.64301 13.9873 6.64301ZM13.9873 4.08758H5.16621C5.01661 4.08758 4.89535 3.96637 4.89535 3.81688C4.89535 3.66738 5.01663 3.54618 5.16621 3.54618H13.9873C14.1369 3.54618 14.2582 3.66738 14.2582 3.81688C14.2582 3.96637 14.1369 4.08758 13.9873 4.08758Z'
          stroke='url(#paint0_linear_12280_28364)'
        />
        <path
          d='M21.2493 4.42157L16.4134 2.89453V3.46232L21.0861 4.93783C21.3662 5.02627 21.5221 5.32595 21.4336 5.60587L16.521 21.145C16.4325 21.4249 16.1326 21.5807 15.8525 21.4922L10.4145 19.7751L7.75 19.1568L15.6893 22.0085C16.2542 22.1869 16.859 21.8727 17.0375 21.3081L21.9501 5.76899C22.1286 5.20441 21.8143 4.59997 21.2493 4.42157Z'
          fill='url(#paint1_linear_12280_28364)'
          stroke='url(#paint2_linear_12280_28364)'
        />
        <path
          d='M16.1549 18.3701V2.07378C16.1549 1.4817 15.673 1 15.0805 1H4.07442C3.48199 1 3 1.4817 3 2.07378V18.3701C3 18.9621 3.48199 19.4438 4.07442 19.4438H15.0805C15.673 19.4439 16.1549 18.9622 16.1549 18.3701ZM3.54174 18.3701V2.07378C3.54174 1.78022 3.7807 1.5414 4.07444 1.5414H15.0805C15.3743 1.5414 15.6132 1.78022 15.6132 2.07378V18.3701C15.6132 18.6636 15.3743 18.9024 15.0805 18.9024H4.07444C3.7807 18.9024 3.54174 18.6636 3.54174 18.3701Z'
          fill='url(#paint3_linear_12280_28364)'
          stroke='url(#paint4_linear_12280_28364)'
        />
        <path
          d='M13.9885 3.54297H5.16734C5.01774 3.54297 4.89648 3.66417 4.89648 3.81367C4.89648 3.96318 5.01776 4.08437 5.16734 4.08437H13.9885C14.1381 4.08437 14.2593 3.96316 14.2593 3.81367C14.2593 3.66416 14.1381 3.54297 13.9885 3.54297Z'
          fill='url(#paint5_linear_12280_28364)'
          stroke='url(#paint6_linear_12280_28364)'
        />
        <path
          d='M13.9885 6.09766H5.16734C5.01774 6.09766 4.89648 6.21884 4.89648 6.36835C4.89648 6.51786 5.01776 6.63905 5.16734 6.63905H13.9885C14.1381 6.63905 14.2593 6.51786 14.2593 6.36835C14.2593 6.21884 14.1381 6.09766 13.9885 6.09766Z'
          fill='url(#paint7_linear_12280_28364)'
          stroke='url(#paint8_linear_12280_28364)'
        />
        <path
          d='M13.9885 8.65625H5.16734C5.01774 8.65625 4.89648 8.77746 4.89648 8.92695C4.89648 9.07646 5.01776 9.19765 5.16734 9.19765H13.9885C14.1381 9.19765 14.2593 9.07645 14.2593 8.92695C14.2593 8.77746 14.1381 8.65625 13.9885 8.65625Z'
          fill='url(#paint9_linear_12280_28364)'
          stroke='url(#paint10_linear_12280_28364)'
        />
        <path
          d='M13.9885 11.207H5.16734C5.01774 11.207 4.89648 11.3282 4.89648 11.4777C4.89648 11.6272 5.01776 11.7484 5.16734 11.7484H13.9885C14.1381 11.7484 14.2593 11.6272 14.2593 11.4777C14.2593 11.3282 14.1381 11.207 13.9885 11.207Z'
          fill='url(#paint11_linear_12280_28364)'
          stroke='url(#paint12_linear_12280_28364)'
        />
        <path
          d='M13.9885 13.7656H5.16734C5.01774 13.7656 4.89648 13.8868 4.89648 14.0363C4.89648 14.1858 5.01776 14.307 5.16734 14.307H13.9885C14.1381 14.307 14.2593 14.1858 14.2593 14.0363C14.2593 13.8868 14.1381 13.7656 13.9885 13.7656Z'
          fill='url(#paint13_linear_12280_28364)'
          stroke='url(#paint14_linear_12280_28364)'
        />
        <path
          d='M13.9885 16.3203H5.16734C5.01774 16.3203 4.89648 16.4415 4.89648 16.591C4.89648 16.7405 5.01776 16.8617 5.16734 16.8617H13.9885C14.1381 16.8617 14.2593 16.7405 14.2593 16.591C14.2593 16.4415 14.1381 16.3203 13.9885 16.3203Z'
          fill='url(#paint15_linear_12280_28364)'
          stroke='url(#paint16_linear_12280_28364)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_28364'
          x1='6.04075'
          y1='2.7268'
          x2='15.4215'
          y2='15.7999'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_28364'
          x1='10.7009'
          y1='4.2013'
          x2='20.8154'
          y2='19.2757'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12280_28364'
          x1='10.7009'
          y1='4.2013'
          x2='20.8154'
          y2='19.2757'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12280_28364'
          x1='5.72409'
          y1='2.25766'
          x2='15.6061'
          y2='16.3844'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint4_linear_12280_28364'
          x1='5.72409'
          y1='2.25766'
          x2='15.6061'
          y2='16.3844'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint5_linear_12280_28364'
          x1='6.83531'
          y1='3.57989'
          x2='6.85312'
          y2='4.19696'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint6_linear_12280_28364'
          x1='6.83531'
          y1='3.57989'
          x2='6.85312'
          y2='4.19696'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint7_linear_12280_28364'
          x1='6.83531'
          y1='6.13457'
          x2='6.85312'
          y2='6.75165'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint8_linear_12280_28364'
          x1='6.83531'
          y1='6.13457'
          x2='6.85312'
          y2='6.75165'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint9_linear_12280_28364'
          x1='6.83531'
          y1='8.69317'
          x2='6.85312'
          y2='9.31025'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint10_linear_12280_28364'
          x1='6.83531'
          y1='8.69317'
          x2='6.85312'
          y2='9.31025'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint11_linear_12280_28364'
          x1='6.83531'
          y1='11.2439'
          x2='6.85312'
          y2='11.861'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint12_linear_12280_28364'
          x1='6.83531'
          y1='11.2439'
          x2='6.85312'
          y2='11.861'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint13_linear_12280_28364'
          x1='6.83531'
          y1='13.8025'
          x2='6.85312'
          y2='14.4196'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint14_linear_12280_28364'
          x1='6.83531'
          y1='13.8025'
          x2='6.85312'
          y2='14.4196'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint15_linear_12280_28364'
          x1='6.83531'
          y1='16.3572'
          x2='6.85312'
          y2='16.9743'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint16_linear_12280_28364'
          x1='6.83531'
          y1='16.3572'
          x2='6.85312'
          y2='16.9743'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_28364'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Documents;
